export const FILE_ALREADY_EXISTS_ERROR = 'BABY_FS_FILE_ALREADY_EXISTS_ERROR';
export const FILE_NOT_FOUND_ERROR = 'BABY_FS_FILE_NOT_FOUND_ERROR';
export const UPSTREAM_ERROR = 'BABY_FS_UPSTREAM_ERROR';
export const NOT_ALLOWED_ERROR = 'BABY_FS_NOT_ALLOWED_ERROR';
export const DIRECTORY_NOT_FOUND_ERROR = 'DIRECTORY_NOT_FOUND_ERROR';
export const NATIVE_BROWSER_PERMISSION_ERROR =
  'BABY_FS_NATIVE_BROWSER_PERMISSION_ERROR';
export const NATIVE_BROWSER_USER_ABORTED_ERROR =
  'BABY_FS_NATIVE_BROWSER_USER_ABORTED_ERROR';
